import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/Index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'Index',
      path: '/',
      component: Index,
      meta: {
        title: '蜜聊伴APP-通过视频跟她聊！'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js